import {APP_ROUTES} from "../app";

export const INDUSTRIES_PAGES_LABELS = {
    INDUSTRIES: 'Industries we serve',
    AGRICULTURE: 'Agriculture',
    TASKS: 'Tasks We Solve',
    CASES: 'Cases',
    PRODUCTS: 'Products',
    HARDWARE: 'Telematics Hardware',
} as const;

export const DIESEL_GENERATORS_PAGE_LABELS = {
    DIESEL_GENERATORS: 'Diesel Generators',
    TASKS: 'Tasks We Solve',
    USERS: 'Users Of The System',
    MONITORING: 'Governance Equipment',
    ONLINE_CONTROL: 'Online control of the generator',
    PARAMETERS: 'Set Parameters Governed',
    GENERATOR_SETS: 'Governing of Generator Sets',
} as const;

export const AGRICULTURE_PAGE_LABELS = {
    TELEMATICS: 'Agricultural telematics',
    FEATURES: 'Features of telematic systems',
} as const;

export const CONSTRUCTION_PAGE_LABELS = {
    CONSTRUCTION: 'Construction',
    OPTIONS: 'Technical options',
    INFO: 'Reports, Options and Notifications',
} as const;

export const LOGISTICS_PAGE_LABELS = {
    LOGISTICS: 'Logistics',
    OPTIONS: 'Technical options',
    INFO: 'Reports, Options and Notifications',
} as const;

export const MARINE_VESSELS_PAGE_LABELS = {
    MARINE_VESSELS: 'Marine Vessels',
    REMOTE_MONITORING: 'Remote Governance of Marine Vessels',
    WATER_TRANSPORT_ADVANTAGES: 'Advantages For Water Transport',
    CONTROLLED_PARAMETERS: 'Controlled parameters',
    TELEMATIC_SYSTEM_DATA: 'Telematic System Data',
} as const;

export const INDUSTRIES_PAGE_BREAD_CRUMB_CONTENT = {
    INDUSTRIES: {title: 'Industries', href: APP_ROUTES.INDUSTRIES},
    MARINE_VESSELS: {title: 'Marine Vessels', href: ''},
    CONSTRUCTION: {title: 'Construction', href: ''},
    LOGISTICS: {title: 'Logistics', href: ''},
    AGRICULTURE: {title: 'Agriculture', href: ''},
    DIESEL_GENERATORS: { title: 'Diesel Generators', href: '' },
};

export const INDUSTRIES_PAGE_BREAD_CRUMB_CONTENT_PH = {
    INDUSTRIES: {title: 'Mga industriya', href: APP_ROUTES.INDUSTRIES},
    MARINE_VESSELS: {title: 'Mga sasakyang pandagat', href: ''},
};

export const DIESEL_GENERATORS_PAGE_TASKS_CARDS_CONTENT = [
    {
        title: 'Real-Time Data Governance',
    },
    {
        title: 'Remote engine diagnostics',
    },
    {
        title: 'Remote management',
    },
    {
        title: 'Fuel usage Governance',
    }
];

export const DIESEL_GENERATORS_PAGE_TASKS_BOTTOM_CONTENT = [
    'Diesel generator governance includes a comprehensive hardware and software solution that allows you to govern the fuel level, control generator operating parameters and perform engine diagnostics. In addition, the system provides electrical data collection and provides the ability to remotely control the installation.',
    'A modern remote governance system for diesel generators helps maintain stable operation of installations, reduces fuel and maintenance costs, improves the planning of technical inspections and reduces the risk of breakdowns, which ultimately increases the service life of generators.',
];

export const DIESEL_GENERATORS_PAGE_USERS_CARDS_CONTENT = [
    {
        title: 'Owners & operators of generators',
        description: 'Remote governance & control of a diesel generator, trucking installations fuel level, ac well ac collecting data for accounting, and maintenance.',
    },
    {
        title: 'Servicing companies',
        description: 'Analysis of engine and generator operation, tracking operating hours, organizing maintenance, as well as timely maintenance and replacement of consumables.',
    },
    {
        title: 'Diesel generator manufacturers',
        description: 'Remote governance of generator set operation, comprehensive installation diagnostics, engine & generator condition governance.',
    },
];

export const DIESEL_GENERATORS_PAGE_MONITORING_CARD_CONTENT = {
    LABEL: ['Generating set governance systems are equipped with the following measuring equipment:'],
    POINTS: [
        'fuel level sensors', 'Modbus RTU converters of data', 'fuel flow meters', 'CAN bus readers', 'I/o modules', 'telematics gateway',
    ]
};

export const DIESEL_GENERATORS_PAGE_MONITORING_CONTENT = ['Key performance indicators are determined using both standard and additional diesel generator sensors. These include fuel level and consumption, as well as information received from the Modbus RTU converter.'];

export const DIESEL_GENERATORS_PAGE_MONITORING_TEXT_BLOCK = [
    'All generator set sensors and controllers are networked using the J1939/S6 interface or S7 wireless technology.',
    'The telematics gateway, also known as the tracking unit, generates generator performance reports based on the collected data and transmits the information via the Internet (2G, 3G, LTE) to a web-based software platform. The operating parameters of the diesel generator can also be viewed on the local screen of the CAN display or installation controller.',
];

export const DIESEL_GENERATORS_PAGE_GENERATOR_SETS_BLOCK = [
    'As soon as the fuel level in the main tank reaches the set value, the unit sends a command to turn off the pump, which ensures reliable operation of the diesel generator.',
    'The J1939 I/O module can stop the generator engine under emergency conditions such as low oil pressure or high coolant temperature, preventing damage.',
];

export const DIESEL_GENERATORS_PAGE_SLIDER_CONTENT = [
    {
        label: 'Fuel Governance for standby gensets in banks',
        task: 'Fuel governing, control of generator operating time and its fuel efficiency.',
        solution: 'DFM 500D CAN',
    },
    {
        label: 'Governing of refueling and remaining fuel',
        task: 'Online governance of the volume of fuel filling in a stationary fuel tank, as well as the total volume of fuel in tanks.',
        solution: 'DUT-E 2Bio differential fuel level sensors and KANUp telematisse gateways.',
    },
    {
        label: 'Alternator and engine parameter remote governance',
        task: 'Providing backup power and remote control of generators',
        solution: 'DFM D fuel flow meters and CANUp Genset telematic gateways.',
    },
];

export const DIESEL_GENERATORS_PAGE_ONLINE_CONTROL_TEXT_BLOCK_CONTENT = {
    LABEL: 'Operating parameters of generators and installations are transmitted in real time. The web-based governance platform provides up-to-date data for each generator or their groups.',
    TEXT: 'Users can govern generator performance over a selected period and generate reports on fuel consumption, power and load. The platform is accessible 24/7 from PCs and smartphones with an Internet connection.',
};

export const DIESEL_GENERATORS_PAGE_PARAMETERS_CONTENT = {
    TEXT: 'The system governs up to 400 generator parameters and transmits data in real time. It also sends reports and SMS notifications about important events such as engine starting and stopping, load changes, accidents and fuel theft.',
};

export const  DIESEL_GENERATORS_PAGE_GENERATORS_SETS_CONTENT  = {
    TEXT: 'Generator governing solutions automate processes. For example, the DUT-E SAU unit uses data from the fuel level sensor to send a signal to the fuel pump relay, ensuring that fuel is pumped from the reservoir to the main tank.'
};

export const AGRICULTURE_PAGE_PRODUCTS_SLIDER_CONTENT = [
    {
        label: 'Fuel level sensor DUT-E',
        href: '/products/fuel-level-sensors/fuel-level-sensor',
    },
    {
        label: 'Fuel flow meter DFM Marine',
        href: '/products/fuel-flow-meters/flow-meter-for-heavy-machinery',
    },
    {
        label: 'Edge computing telematics gateway',
        href: '/products/telematic-gateway',
    },
];

export const AGRICULTURE_PAGE_PRODUCTS_SLIDER_CONTENT_PH = [
    {
        label: 'asdasda',
        href: '/products/fuel-level-sensors/fuel-level-sensor',
    },
    {
        label: 'asdasd',
        href: '/products/fuel-flow-meters/flow-meter-for-heavy-machinery',
    },
    {
        label: 'asdasdasd',
        href: '/products/telematic-gateway',
    },
];

export const AGRICULTURE_PAGE_CASES_SLIDER_CONTENT = [
    {
        label: 'Agricultural company',
        task: 'Fuel consumption governance',
        solution: 'DFM fuel flow meter',
    },
    {
        label: 'JV BEK CLUSTER – agricultural producer',
        task: 'Fuel consumption governance of agricultural vehicles',
        solution: 'Differential DFM D fuel flow meters',
    },
    {
        label: 'Manufacturer of cotton and cotton products',
        task: 'Fuel consumption and machine hours governance, hours worked and quality of work of drivers tracking',
        solution: 'DFM D fuel flow meters with CAN interface, telematics unit with CAN input, telematics service',
    },
];

export const AGRICULTURE_PAGE_TASKS_CARDS_CONTENT = [
    {
        title: 'Fuel Consumption Governance',
    },
    {
        title: 'Fuel Tank Governance',
    },
    {
        title: 'Fuel theft prevention',
    },
    {
        title: 'Machine running time tracking',
    },
    {
        title: 'Remote engine diagnostics',
    },
];

export const AGRICULTURE_PAGE_TELEMATICS_CARDS_CONTENT = [
    {
      title: 'Fuel Governance',
      description: 'Helps to identify excess costs, reduce consumption rates and control refueling, which is natural for ensuring economy.',
    },
    {
        title: 'Operation parameters governance',
        description: 'Allows operators to control compliance with technological processes, equipment efficiency and such important indicators as speed and temperature.',
    },
    {
        title: 'Machine running time tracking',
        description: 'Helps to more accurately plan the time spent on tasks and implement a payment system based on actual hours worked.',
    },
    {
        title: 'GPS tracking',
        description: 'Provides data on the location of equipment and its movement, which helps to identify cases of improper use of the machine.',
    },
];

export const AGRICULTURE_PAGE_TELEMATICS_BOTTOM_CARD_CONTENT = {
    LIST: {
        LABEL: 'Effects of implementing monitoring system:',
        TEXT: ['Reduce fuel costs by optimizing consumption and preventing theft.', 'Reduce maintenance costs through remote diagnostics and forecasting repair times.', 'Increase fleet efficiency through simplification and increased discipline.'],
    },
    TEXT: 'Depending on the fleet condition, the telematics system can reduce overall fuel costs by up to 30%, which has a significant impact on the budget. In addition, it can reduce repair and maintenance costs by 20%, thanks to more efficient resource management and preventive maintenance. ',
};

export const AGRICULTURE_PAGE_HARDWARE_LABEL = 'The tractor telematics system uses various devices to operate the triptych equipment. These include:';

export const AGRICULTURE_PAGE_TELEMATICS_HARDWARE_CARD_CONTENT = [
    {
        title: 'Fuel flow meter',
        description: 'Installed in the fuel system and provides accurate consumption data.',
    },
    {
        title: 'Digital-to-analog converter',
        description: 'Provides interaction between digital and traditional devices in the system.',
    },
    {
        title: 'Contactless reader',
        description: 'Reads data from the CAN bus without connection.',
    },
    {
        title: 'Driver display',
        description: 'Monitors more than 3,500 equipment operating parameters.',
    },
    {
        title: 'Fuel level sensor',
        description: 'Easy to configure and measures the amount of fuel, regardless of the shape of the tank.',
    },
    {
        title: 'Telematics gateway',
        description: 'Collects data from various sensors and sends it to an online service.',
    },
];

export const CONSTRUCTION_PAGE_TASKS_CARDS_CONTENT = [
    {
        title: 'Fuel consumption monitoring',
    },
    {
        title: 'Fuel theft prevention',
    },
    {
        title: 'Location control',
    },
    {
        title: 'Machine running time tracking',
    },
    {
        title: 'Axle load and cargo weight',
    },
];

export const CONSTRUCTION_PAGE_TASKS_TEXT_CONTENT = [
    'Monitoring fuel governance and operating modes of mining and quarry equipment allows you to reduce operating costs, prevent fuel theft and equipment failure',
    'For quarry equipment, the basic solution is DFM Marine fuel flow meters with a maximum flow rate of up to 4,000 l/h. DUT-E fuel level sensors can be added for precise measurement, as well as a GNOM axle load/shift sensor for monitoring the weight and position of the bucket.',
];

export const CONSTRUCTION_PAGE_OPTIONS_CARDS_CONTENT = [
    {
        title: 'Fuel control in the tank'
    },
    {
        title: 'Fuel control in the line'
    },
    {
        title: 'Loader operation control'
    },
    {
        title: 'Control of dump trucks operation'
    },
];

export const CONSTRUCTION_PAGE_CASES_SLIDER_CONTENT = [
    {
        label: 'Oil production company',
        task: 'Сontrol of fuel consumption',
        solution: 'DFM fuel flow meters',
    },
    {
        label: 'Thiess, mining services provider',
        task: 'Fuel volume monitoring for planning machinery operation',
        solution: 'DUT-E fuel level sensor + tracking device',
    },
    {
        label: 'Quarry for gypsum mining',
        task: 'Accounting of fuel consumption per ton of product',
        solution: 'DFM Marine fuel flow meters, telematics control unit and software',
    },
];

export const CONSTRUCTION_PAGE_ACCORDION_BLOCK_CONTENT = [
    {
        id: '1',
        title: 'Fuel consumption control',
        items: [
            'Hourly fuel consumption in “Forward”/“Return” line', 'Total fuel consumption, L', 'Total fuel consumption in “Idling”/“Optimal”/“Overload” mode of engine operation', 'Total fuel consumption in “Negative” mode of flow meter operation (return exceeds supply)',
        ],
    },
    {
        id: '2',
        title: 'Data for reports',
        items: [
            'Operating time of ICE (engine hours)', 'Mileage', 'Fuel consumption per shift', 'Cargo weight',
        ],
    },
    {
        id: '3',
        title: 'Operating parameters monitoring',
        items: [
          'Fuel temperature', 'Temperature correction status', 'Correction coefficient value', 'Battery charge',
        ],
    },
    {
        id: '4',
        title: 'Informing about intervention',
        items: [
            'Engine operating time in “Tampering” mode, h',  'Engine operating time in “Interference” mode, h',
        ],
    },
];

export const LOGISTICS_PAGE_TASKS_CARDS_CONTENT = [
    {
        title: 'Recording engine operation hours in various workloads',
    },
    {
        title: 'Fuel consumption measurement split by workload mode',
    },
    {
        title: 'Monitoring fuel volume in tank, prevention of fuel draining',
    },
    {
        title: 'Engine and ECU health check, detecting DTCs',
    },
    {
        title: 'Measuring axle load and cargo weight, preventing axle overload',
    },
];

export const LOGISTICS_PAGE_TASKS_TEXT_CONTENT = [
    'About 50% of fleet costs are related to fuel and truck maintenance. Reducing fuel and maintenance costs can improve fleet efficiency and lead to additional vehicle operating profits that can be used to further grow your business.',
    'Truck telematics systems help reduce maintenance costs by using a predictive approach. This means that maintenance is performed based on actual engine operating conditions, and filters, tires, and other consumables are replaced as they wear out, rather than on a predetermined schedule.',
];

export const LOGISTICS_PAGE_TASKS_CARD_CONTENT = {
    LABEL: 'By equipping trucks with telematics equipment, the company owner gets the opportunity to:',
    POINTS: [
        'Track route and location of the trucks using GPS', 'Detect risky driving, speeding, leaving the route', 'See cargo weight and prevent unauthorized cargo loading or unloading', 'Monitor current axle load and avoid fees for exceeding maximum load per axle', 'Improve efficiency of fuel consumption and increase fuel economy', 'Detect fuel theft from truck’s tank or engine fuel system', 'Monitor engine health, detect DTCs or other ECU errors',
    ],
};

export const LOGISTICS_PAGE_TELEMATIC_FEATURES_CARDS_CONTENT = [
    {
        title: 'Fuel volume monitoring',
    },
    {
        title: 'Axle load monitoring',
    },
    {
        title: 'Engine monitoring  and diagnostics',
    },
    {
        title: 'Vehicle power supply monitoring',
    },
    {
        title: 'Route and location tracking',
    },
];

export const LOGISTICS_PAGE_TELEMATIC_FEATURES_VOLUME_CARD_CONTENT = {
    LABEL: 'Fuel volume monitoring in the fuel tank',
    TITLE: 'Monitored parameters and events:',
    POINTS: [
        'Fuel volume in each fuel tank or compartment, L or %', 'Fuel level, mm', 'Temperature in each fuel tank or compartment', 'Volume of fuel, refueled at fuel stations, volume of stolen fuel', 'Locations of refueling a tank and draining fuel', 'Detection of adding extraneous liquids to fuel in the tank',
    ],
};

export const LOGISTICS_PAGE_TELEMATIC_FEATURES_CONSUMPTION_CARD_CONTENT = {
    LABEL: 'Fuel consumption monitoring in the fuel line',
    TITLE: 'Monitored parameters:',
    POINTS: [
        'Actual fuel consumption in the fuel line with measurement inaccuracy not more than 1-3%', 'Fuel consumption in different operation modes: “Idling”, “Optimal”, “Overload”', 'Detection of attempts of tampering data and interference in the flow meter operation',
    ],
};

export const LOGISTICS_PAGE_CASES_SLIDER_CONTENT = [
    {
        label: 'Distributor of household appliances and electronics',
        task: 'Fuel tank monitoring and GPS-tracking',
        solution: 'DUT-E S7 wireless fuel level sensors, CANUp telematics gateways',
    },
    {
        label: 'Engine remote blocking of leasing highway trucks',
        task: 'Remote blocking (immobilization) of engine',
        solution: 'CANUp gateway, MasterCAN DAC converter',
    },
];

export const LOGISTICS_PAGE_TELEMATICS_FEATURES_TEXTS = [
    'Graph of the volume (level) of fuel in the tank',
    'Graph of the hourly fuel consumption',
];

export const LOGISTICS_PAGE_TELEMATICS_FEATURES_NOTE = '*depends on fuel flow meter model and mounting layout in the fuel line';

export const MARINE_VESSELS_PAGE_REMOTE_MONITORING_TEXT = [
    'The fuel consumption governance system helps reduce costs, improve safety and improve the accuracy of CO2 emissions calculations. These solutions improve efficiency and meet environmental standards.',
    'Telematics technologies analyze the performance of ship systems such as engines and generators on small and medium-sized vessels, including tugs and ferries. Data is available both on board and remotely in the form of graphs and tables.',
];

export const MARINE_VESSELS_PAGE_REMOTE_MONITORING_TEXT_PH = [
    '',
    '',
];

export const MARINE_VESSELS_PAGE_REMOTE_MONITORING_CARDS_CONTENT = [
    {
        label: 'Accurate fuel consumption accounting',
        content: [
            'Determining the actual fuel consumption of all consumers', 'Detection of inefficient operation of diesel generators and boilers', 'Clarification of CO2 emission calculation (based on fuel consumption)', 'Clarification of fuel consumption standards for consumers on board', 'Development of measures and methods for fuel economy',
        ]
    },
    {
        label: 'Preventing fuel theft',
        content: [
            'Elimination of fuel consumption overstatements', 'Monitoring the actual operating time of fuel consumers', 'Exclusion of work time additions', 'Preventing fuel line leaks', 'Instrumentally accurate measurement of fuel consumption',
        ]
    },
    {
        label: 'Remote diagnostics',
        content: [
            'Elimination of fuel consumption overstatements', 'Monitoring the actual operating time of fuel consumers', 'Exclusion of work time additions', 'Preventing fuel line leaks', 'Instrumentally accurate measurement of fuel consumption',
        ]
    },
    {
        label: 'Route and location tracking',
        content: [
            'Elimination of fuel consumption overstatements', 'Monitoring the actual operating time of fuel consumers', 'Exclusion of work time additions', 'Preventing fuel line leaks', 'Instrumentally accurate measurement of fuel consumption',
        ]
    },
];

export const MARINE_VESSELS_PAGE_REMOTE_MONITORING_CARDS_CONTENT_PH = [
    {
        label: 'asdasdasd',
        content: [
            'Determining the actual fuel consumption of all consumers', 'Detection of inefficient operation of diesel generators and boilers', 'Clarification of CO2 emission calculation (based on fuel consumption)', 'Clarification of fuel consumption standards for consumers on board', 'Development of measures and methods for fuel economy',
        ]
    },
    {
        label: 'asdasdas',
        content: [
            'Elimination of fuel consumption overstatements', 'Monitoring the actual operating time of fuel consumers', 'Exclusion of work time additions', 'Preventing fuel line leaks', 'Instrumentally accurate measurement of fuel consumption',
        ]
    },
    {
        label: 'asdasd',
        content: [
            'Elimination of fuel consumption overstatements', 'Monitoring the actual operating time of fuel consumers', 'Exclusion of work time additions', 'Preventing fuel line leaks', 'Instrumentally accurate measurement of fuel consumption',
        ]
    },
    {
        label: 'asdasdasd',
        content: [
            'Elimination of fuel consumption overstatements', 'Monitoring the actual operating time of fuel consumers', 'Exclusion of work time additions', 'Preventing fuel line leaks', 'Instrumentally accurate measurement of fuel consumption',
        ]
    },
];

export const MARINE_VESSELS_PAGE_CONTROLLED_PARAMETERS_CARDS_CONTENT = [
    {
        label: 'Fuel',
        content: [
            'Total fuel consumption;', 'Consumption in the "Idle" and "Optimal" modes;', 'Fuel temperature;', 'Fuel level in tanks;', 'Instantaneous fuel consumption in engines, generators, boilers.',
        ],
    },
    {
        label: 'Engine',
        content: [
            'Operating time in engine hours;', 'Operating time in the Idle and Optimal modes;', 'Coolant temperature;', 'Engine oil pressure;', 'Engine operating mode: Idle, Optimal, Overload.',
        ],
    },
    {
        label: 'Data and events',
        content: [
            'Events "On/Off", "Data Distortion";', 'Operating time within the events;', 'Fuel consumption in "Distortion" mode;', 'Data from the main and additional analog sensors.',
        ],
    },
];

export const MARINE_VESSELS_PAGE_CONTROLLED_PARAMETERS_CARDS_CONTENT_PH = [
    {
        label: 'asdsadasd',
        content: [
            'Total fuel consumption;', 'Consumption in the "Idle" and "Optimal" modes;', 'Fuel temperature;', 'Fuel level in tanks;', 'Instantaneous fuel consumption in engines, generators, boilers.',
        ],
    },
    {
        label: 'sadasdsa',
        content: [
            'Operating time in engine hours;', 'Operating time in the Idle and Optimal modes;', 'Coolant temperature;', 'Engine oil pressure;', 'Engine operating mode: Idle, Optimal, Overload.',
        ],
    },
    {
        label: 'Datasdasa and asdadasd',
        content: [
            'Events "On/Off", "Data Distortion";', 'Operating time within the events;', 'Fuel consumption in "Distortion" mode;', 'Data from the main and additional analog sensors.',
        ],
    },
];

export const MARINE_VESSELS_PAGE_SYSTEM_DATA_CONTENT = {
    TEXT: 'The control data is transmitted via the CANUp telematics gateway and is available remotely in the reports of telematics service applications. These applications allow you to customize the control panel to display key information on a single screen.',
    LABEL: 'The system can automatically send reports and notifications about important events, such as engine shutdown.',
    POINTS: [
        'The vessel can install the MasterCAN Display 35 in the captain\'s cabin, and some DFM flow meter models have a built-in screen.',
        'Devices with S7 technology transmit data to terminals and smartphones via BLE (Bluetooth Low Energy).',
    ],
};

export const MARINE_VESSELS_PAGE_SYSTEM_DATA_CONTENT_PH = {
    TEXT: 'The control data is transmitted via the CANUp telematics gateway and is available remotely in the reports of telematics service applications. These applications allow you to customize the control panel to display key information on a single screen.',
    LABEL: 'The system can automatically send reports and notifications about important events, such as engine shutdown.',
    POINTS: [
        'Taasdasdasd',
        'asdasdas',
    ],
};

export const MARINE_VESSELS_PAGE_EQUIPMENT_TEXT_PH = 'asasdasd';

export const MARINE_VESSELS_PAGE_TABLE_CONTENT = {
    LABELS: [
        'For ship owners', 'For integrators',
    ],
    CONTENT: [
        {
            first_column: 'Save up to 50% on fuel',
            second_column: 'Quick and easy installation of equipment using S6 technology',
        },
        {
            first_column: 'Remote diagnostics of generators and boilers',
            second_column: 'Fuel consumption control using tools',
        },
        {
            first_column: 'Preventive maintenance to extend service life',
            second_column: 'Integration with other telematics and fleet systems',
        },
        {
            first_column: 'Route, speed and operation monitoring',
            second_column: 'Easy connection of a sensor network using S6 technology',
        },
        {
            first_column: 'Determination of fuel consumption in the "Idle" and "Optimum" modes',
            second_column: 'Compatibility with previously installed sensors and services',
        },
        {
            first_column: 'First-time event notifications via telematics service, SMS or email',
            second_column: 'Simple connection to gateways and controllers ',
        },
        {
            first_column: 'Affordable price and flexible settings',
            second_column: 'Remote control of ship systems',
        },
        {
            first_column: 'Compatibility of sensors and flow meters with atmospheric and modern vessels...',
            second_column: 'Remote configuration of sensors',
        },
        {
            first_column: 'Easy integration with the fleet management sequence',
            second_column: 'Reading and analysis of data from CAN J1939 and NMEA2000',
        },
        {
            first_column: 'Data display on the NMEA2000 display',
            second_column: '',
        },
    ],
};

export const MARINE_VESSELS_PAGE_TABLE_CONTENT_PH = {
    LABELS: [
        'asdasdsad', 'asdsadasd',
    ],
    CONTENT: [
        {
            first_column: 'asdasdl',
            second_column: 'asdasda',
        },
        {
            first_column: 'Remote diagnostics of generators and boilers',
            second_column: 'Fuel consumption control using tools',
        },
        {
            first_column: 'Preventive maintenance to extend service life',
            second_column: 'Integration with other telematics and fleet systems',
        },
        {
            first_column: 'Route, speed and operation monitoring',
            second_column: 'Easy connection of a sensor network using S6 technology',
        },
        {
            first_column: 'Determination of fuel consumption in the "Idle" and "Optimum" modes',
            second_column: 'Compatibility with previously installed sensors and services',
        },
        {
            first_column: 'First-time event notifications via telematics service, SMS or email',
            second_column: 'Simple connection to gateways and controllers ',
        },
        {
            first_column: 'Affordable price and flexible settings',
            second_column: 'Remote control of ship systems',
        },
        {
            first_column: 'Compatibility of sensors and flow meters with atmospheric and modern vessels...',
            second_column: 'Remote configuration of sensors',
        },
        {
            first_column: 'Easy integration with the fleet management sequence',
            second_column: 'Reading and analysis of data from CAN J1939 and NMEA2000',
        },
        {
            first_column: 'Data display on the NMEA2000 display',
            second_column: '',
        },
    ],
};

export const MARINE_VESSELS_PAGE_CASES_SLIDER_CONTENT = [
    {
        label: 'Ventspils port',
        task: 'Monitoring of fuel consumption and prevention of manipulations with fuel',
        solution: 'DFM 250 AK fuel flow meters for gensets and DFM 250 DK for engines',
    },
    {
        label: 'Transportation company',
        task: 'Fuel consumption monitoring of river vessels and optimization of routes',
        solution: 'DFM 250CCAN fuel flow meters, DFM 100CCAN fuel flow meters, GPS-trackers',
    },
    {
        label: 'Bunkering company',
        task: 'Fuel consumption monitoring.',
        solution: 'DFM fuel flow meters',
    },
];

export const MARINE_VESSELS_PAGE_CASES_SLIDER_CONTENT_PH = [
    {
        label: 'asdasdasdsada',
        task: 'Monitoring of fuel consumption and prevention of manipulations with fuel',
        solution: 'DFM 250 AK fuel flow meters for gensets and DFM 250 DK for engines',
    },
    {
        label: 'asdasdasdas',
        task: 'Fuel consumption monitoring of river vessels and optimization of routes',
        solution: 'DFM 250CCAN fuel flow meters, DFM 100CCAN fuel flow meters, GPS-trackers',
    },
    {
        label: 'asdsadasd',
        task: 'Fuel consumption monitoring.',
        solution: 'DFM fuel flow meters',
    },
];